import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from './Select';

class CurrencyInput extends Component {
  static get propTypes() {
    return {
      onChange: PropTypes.func.isRequired,
      value: PropTypes.string,
      isDisabled: PropTypes.bool,
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      required: PropTypes.bool,
      isClearable: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      value: '',
      placeholder: '',
      isDisabled: false,
      required: false,
      isClearable: false,
    };
  }

  render() {
    const {
      name,
      isDisabled,
      onChange,
      value,
      required,
      isClearable,
      placeholder,
    } = this.props;
    return (
      <Select
        name={name}
        isDisabled={isDisabled}
        value={value}
        onChange={onChange}
        options={[
          { value: 'SEK', label: 'SEK' },
          { value: 'NOK', label: 'NOK' },
          { value: 'DKK', label: 'DKK' },
          { value: 'EUR', label: 'EUR' },
          { value: 'USD', label: 'USD' },
          { value: 'GBP', label: 'GBP' },
        ]}
        placeholder={placeholder}
        required={required}
        isClearable={isClearable}
      />
    );
  }
}

export default CurrencyInput;
